module.exports = __webpack_public_path__ + "img/SHU.78c67ba1.png";